import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import logo from './assets/Firebucks_logo.png';
import './Navbar.css';

const LINKS = [
  ['/', 'Home'],
  ['/about-us', 'About Us'],
  ['/services', 'Services'],
  ['/products', 'Products'],
  ['/careers', 'Careers'],
  ['/industries', 'Industries'],
  ['/contact-us', 'Contact'],
];

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
  const [navbarHeight, setNavbarHeight] = useState(0);
  const [navHidden, setNavHidden] = useState(false);
  const navbarRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
      setNavbarHeight(navbarRef.current?.offsetHeight || 0);
    };
    setNavbarHeight(navbarRef.current?.offsetHeight || 0);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  /* Hide the bar on scroll down, reveal on scroll up. */
  useEffect(() => {
    let lastY = window.scrollY;
    let ticking = false;
    const update = () => {
      const y = window.scrollY;
      if (menuOpen) setNavHidden(false);
      else if (y > 140 && y > lastY + 6) setNavHidden(true);
      else if (y < lastY - 6 || y <= 140) setNavHidden(false);
      lastY = y;
      ticking = false;
    };
    const onScroll = () => { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [menuOpen]);

  const toggleMenu = () => setMenuOpen((p) => !p);
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <nav
      ref={navbarRef}
      className={`navbarx fixed top-0 w-full z-50 bg-white border-b border-gray-200 flex items-center h-20 text-lg px-4 transition-transform duration-300 ease-out ${navHidden ? '-translate-y-full' : 'translate-y-0'}`}
    >
      {/* Logo */}
      <div className="absolute left-6 flex items-center h-full">
        <Link to="/" onClick={() => { scrollToTop(); setMenuOpen(false); }}>
          <img src={logo} alt="logo" className="h-6 w-auto object-contain" />
        </Link>
      </div>

      {/* Desktop Menu */}
      <ul className="hidden lg:flex text-[18px] lg:flex-row gap-6 h-full items-center justify-center mx-auto">
        {LINKS.map(([to, label]) => (
          <li key={to} className="flex items-center cursor-pointer px-4">
            <Link to={to} onClick={scrollToTop} className="hover:text-red-600 transition">{label}</Link>
          </li>
        ))}
      </ul>

      {/* Mobile Hamburger */}
      <div className="absolute right-12 flex flex-col justify-center items-center cursor-pointer lg:hidden" onClick={toggleMenu}>
        <div className={`flex flex-col justify-between w-8 h-6 ${menuOpen ? 'open' : ''}`}>
          <span className={`block h-1 bg-black transition-transform duration-300 ${menuOpen ? 'transform rotate-45 translate-y-2' : ''}`}></span>
          <span className={`block h-1 bg-black transition-opacity duration-300 ${menuOpen ? 'opacity-0' : ''}`}></span>
          <span className={`block h-1 bg-black transition-transform duration-300 ${menuOpen ? 'transform -rotate-45 -translate-y-2' : ''}`}></span>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobile && menuOpen && (
        <ul className="absolute left-0 w-full bg-gray-900 text-white border-t border-gray-700 shadow-lg" style={{ top: `${navbarHeight}px` }}>
          {LINKS.map(([to, label]) => (
            <li key={to} className="py-3 px-4 border-b border-gray-700 transition">
              <Link to={to} onClick={() => { scrollToTop(); toggleMenu(); }} className="block text-gray-300 hover:text-red-600 transition">
                {label}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
};

export default Navbar;
